import { IconProps } from "./HomeIcon";

const BioinformaticsIcon = ({ color = "#999999" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0449 4.99994C13.0449 5.82831 12.3734 6.49988 11.5449 6.49988C10.7165 6.49988 10.0449 5.82831 10.0449 4.99994C10.0449 4.17157 10.7165 3.5 11.5449 3.5C12.3734 3.5 13.0449 4.17157 13.0449 4.99994ZM14.5449 4.99994C14.5449 6.39998 13.5858 7.57603 12.2888 7.90693C12.2926 7.93742 12.2946 7.96848 12.2946 8V13.4732L16.9561 16.1645C17.5 15.6144 18.2551 15.2734 19.0898 15.2734C20.7467 15.2734 22.0898 16.6166 22.0898 18.2734C22.0898 19.9302 20.7467 21.2733 19.0898 21.2733C17.433 21.2733 16.0898 19.9302 16.0898 18.2734C16.0898 17.9917 16.1287 17.7192 16.2012 17.4607L11.5446 14.7723L6.88853 17.4604C6.96116 17.7189 7 17.9916 7 18.2734C7 19.9302 5.65685 21.2733 4 21.2733C2.34315 21.2733 1 19.9302 1 18.2734C1 16.6166 2.34315 15.2734 4 15.2734C4.83461 15.2734 5.58961 15.6142 6.13343 16.1643L10.7946 13.4732V8C10.7946 7.96842 10.7965 7.9373 10.8003 7.90675C9.50365 7.5756 8.54492 6.39973 8.54492 4.99994C8.54492 3.34312 9.88807 2 11.5449 2C13.2018 2 14.5449 3.34312 14.5449 4.99994ZM20.5898 18.2734C20.5898 19.1017 19.9183 19.7733 19.0898 19.7733C18.2614 19.7733 17.5898 19.1017 17.5898 18.2734C17.5898 17.445 18.2614 16.7734 19.0898 16.7734C19.9183 16.7734 20.5898 17.445 20.5898 18.2734ZM4 19.7733C3.17154 19.7733 2.5 19.1017 2.5 18.2734C2.5 17.445 3.17154 16.7734 4 16.7734C4.82846 16.7734 5.5 17.445 5.5 18.2734C5.5 19.1017 4.82846 19.7733 4 19.7733Z"
        fill={color}
      />
    </svg>
  );
};

export default BioinformaticsIcon;
